// @flow
import * as React from 'react';
import BottomBanner from 'app/common/react/components/experiences/ExperienceBottomBanner/BottomBanner';
import Experience from 'app/common/react/components/experiences/Experience/Experience';
import toCamelCase from 'app/common/lib/util/toCamelCase';
import { deepMapStringKeys } from 'app/common/lib/util/ObjectUtils';

type ExperienceBottomBannerProps = { placementId: number };

// NOTE(jkim): Consider creating new BOTTOM_BANNER experience type so we don't
// have to maintain this whitelist.
const BOTTOM_BANNER_EXPERIENCES = [
  PCONST.thrift.Experience.WEB_SEO_NUX_HOMEFEED_WELCOME,
  PCONST.thrift.Experience.WEB_SEO_NUX_HOMEFEED_PIN_SUCCESS_BANNER,
  PCONST.thrift.Experience.WEB_PROFILE_REFRESH_BOTTOMBANNER,
];

const ExperienceBottomBanner = ({ placementId }: ExperienceBottomBannerProps) => (
  <Experience placementId={placementId} experienceIds={BOTTOM_BANNER_EXPERIENCES}>
    {({ complete, dismiss, display_data }) => (
      <BottomBanner
        {...deepMapStringKeys(toCamelCase)(display_data)}
        handleComplete={complete}
        handleDismiss={dismiss}
      />
    )}
  </Experience>
);

export default ExperienceBottomBanner;
